import { styled as mstyled } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'

const StyledTab = mstyled(Tab)(() => ({
  minWidth: '48px',
  padding: '13px 0px',
  opacity: '1',
  marginLeft: '12px',
  ['@media (min-width:768px)']: {
    marginLeft: (props: any) => (props.value === 'article' ? '0px' : '12px'),
    minWidth: '80px',
    padding: '16px 0px',
  },
  color: '#999999',
  '&.Mui-selected': {
    color: 'black',
  },
}))

export default StyledTab
